import React, { useEffect, useState } from "react";
import MaterialBox from "../../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialInput from "../../../../components/MaterialInput";
import {
  CardContent,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Switch,
} from "@mui/material";
import MaterialButton from "../../../../components/MaterialButton";
import MaterialSelect from "../../../../components/MasterSelect";
import { useNavigate } from "react-router-dom";
import { fetchData } from "../../../../services";

export const MotorBodyStyleForm = ({ editBodyStyleData, onsubmit }) => {
  const navigate = useNavigate();
  const [bodyStyleData, setBodyStyleData] = useState({
    // body style information
    name: "",
    motorBodyType: "",
    active: true,

    // body style information status
    nameStatus: "unchecked",
    motorBodyTypeStatus: "unchecked",
  });

  const [motorBodyTypeOptions, setMotorBodyTypeOptions] = useState([]);

  useEffect(() => {
    if (editBodyStyleData) {
      setBodyStyleData((prevData) => ({
        ...prevData,
        ...editBodyStyleData,
        motorBodyType: {
          label: editBodyStyleData?.bodyType?.name,
          value: editBodyStyleData?.bodyType?.id,
        },
        nameStatus: editBodyStyleData?.name ? "success" : "unchecked",
        motorBodyTypeStatus: editBodyStyleData?.bodyType
          ? "success"
          : "unchecked",
      }));
    }
  }, [editBodyStyleData]);

  const fetchBodyTypeData = async () => {
    try {
      const response = await fetchData(
        `/reference/motor/body-type?isActive=true&dropdown=true`
      );

      setMotorBodyTypeOptions(
        response?.data?.items.map((item) => ({
          label: item.name,
          value: item.id,
        }))
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchBodyTypeData();
  }, []);

  const handleBodyStyleDataChange = (event, selectEvent) => {
    let bodyStyleState = { ...bodyStyleData };

    const changeAllowed = true;

    if (event?.target === undefined && selectEvent) {
      switch (selectEvent.name) {
        case "motorBodyType":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              bodyStyleState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              bodyStyleState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "active":
          {
            const value = event.target.value;
            bodyStyleState[event.target.name] = value;
          }
          break;

        default:
          break;
      }
      bodyStyleState[selectEvent.name] = event;
    } else if (event) {
      switch (event.target.name) {
        case "name":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9 ]{2,20})$");

            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              bodyStyleState[event.target.name + "Status"] = "success";
            } else {
              bodyStyleState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        default:
          break;
      }
      if (changeAllowed) {
        bodyStyleState[event.target.name] = event.target.value;
      }
    }
    setBodyStyleData(bodyStyleState);
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      bodyStyleData.nameStatus === "success" &&
      bodyStyleData.motorBodyTypeStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handleSubmit = () => {
    if (checkAllFields()) {
      onsubmit(bodyStyleData);
    }
  };

  return (
    <div>
      <CardContent sx={{ minHeight: "50vh" }}>
        <MaterialBox>
          <Grid container spacing={1}>
            <Grid size={{ xs: 12, sm: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Body Style Name*
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="name"
                placeholder="eg. Sedan"
                value={bodyStyleData.name}
                onChange={handleBodyStyleDataChange}
                error={bodyStyleData.nameStatus === "error" ? true : false}
                success={bodyStyleData.nameStatus === "success" ? true : false}
              />
              {bodyStyleData.nameStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Name should be maximum 20 characters long and can contain
                    only alphabets
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Motor Body Type*
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="motorBodyType"
                value={bodyStyleData.motorBodyType}
                customStyles={{ optionPadding: 20 }}
                onChange={handleBodyStyleDataChange} //selectedValue, event
                options={motorBodyTypeOptions?.map((value) => {
                  return {
                    value: value.value,
                    label: value.label,
                  };
                })}
                error={
                  bodyStyleData.motorBodyTypeStatus === "error" ? true : false
                }
                success={
                  bodyStyleData.motorBodyTypeStatus === "success" ? true : false
                }
                isClearable
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 2 }}>
              <MaterialBox>
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Active
                </MaterialTypography>
              </MaterialBox>
              <FormControlLabel
                control={
                  <Switch
                    name="active"
                    checked={bodyStyleData.active}
                    onChange={(event) =>
                      handleBodyStyleDataChange({
                        target: {
                          name: "active",
                          value: event.target.checked,
                        },
                      })
                    }
                    color="primary"
                  />
                }
                label={
                  <MaterialTypography variant="caption" fontWeight="bold">
                    {bodyStyleData?.active ? "Yes" : "No"}
                  </MaterialTypography>
                }
                sx={{ marginLeft: 0 }}
              />
            </Grid>
          </Grid>
        </MaterialBox>
      </CardContent>
      <MaterialBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <MaterialButton
          sx={{ m: 2 }}
          variant="outlined"
          color="dark"
          onClick={() => {
            navigate("/motor-master/motor-bodyStyle");
          }}
        >
          Cancel
        </MaterialButton>
        <MaterialButton
          sx={{ m: 2 }}
          variant="gradient"
          color="dark"
          disabled={!checkAllFields()}
          onClick={handleSubmit}
        >
          Submit
        </MaterialButton>
      </MaterialBox>
    </div>
  );
};
